var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDiner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 0C1.5 0 0 1.5 0 3.33333V20.6667C0 22.5 1.5 24 3.33333 24H30C31.8333 24 33.3333 22.5 33.3333 20.6667V3.33333C33.3333 1.5 31.8333 0 30 0H3.33333ZM3.33333 1.33333H30C31.112 1.33333 32 2.22135 32 3.33333V20.6667C32 21.7786 31.112 22.6667 30 22.6667H3.33333C2.22135 22.6667 1.33333 21.7786 1.33333 20.6667V3.33333C1.33333 2.22135 2.22135 1.33333 3.33333 1.33333ZM15.3333 5.33333C11.6589 5.33333 8.66667 8.32552 8.66667 12C8.66667 15.6745 11.6589 18.6667 15.3333 18.6667H17.3333C21.0156 18.6667 24 15.6823 24 12C24 8.31771 21.0156 5.33333 17.3333 5.33333H15.3333ZM15.3333 6.66667C18.2865 6.66667 20.6667 9.04688 20.6667 12C20.6667 14.9531 18.2865 17.3333 15.3333 17.3333C12.3802 17.3333 10 14.9531 10 12C10 9.04688 12.3802 6.66667 15.3333 6.66667ZM14.2292 8.875C12.9323 9.33073 12 10.5469 12 12C12 13.4531 12.9323 14.6693 14.2292 15.125V8.875ZM16.4375 8.875V15.125C17.7344 14.6693 18.6667 13.4531 18.6667 12C18.6667 10.5469 17.7344 9.33073 16.4375 8.875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDiner);
export default __webpack_public_path__ + "static/media/logo-diner.eaff9b6d168edcf0886cc916c7c164f5.svg";
export { ForwardRef as ReactComponent };